export default class FileUtils {
    static isSupportedImage(file: File): boolean {
        const MAX_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
        const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png', 'image/gif'];

        if (file.size > MAX_SIZE) return false;
        if (!SUPPORTED_IMAGE_FORMATS.includes(file.type)) return false;

        return true;
    }
}
